module.exports = __webpack_public_path__ + "static/media/1013028.24dd9806.jpg";